module.exports = __webpack_public_path__ + "assets/900f999c09f1d74ad3c7349bca74aa4f.png";